import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps, mergeComponentProps as _mergeComponentProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("header-dropdown__headerdropdowncontainer-34ujsc", {
  padding: "16px",
  width: "min-content",
  maxWidth: "700px"
});
const _staticStyles2 = _cssRef("header-dropdown__headerdropdowninnercontainer-118goa", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start"
});
const _staticStyles3 = _cssRef("header-dropdown__locationtextrowset-0xk8p7", {
  paddingRight: "16px"
});
const _staticStyles4 = _cssRef("header-dropdown__locationprimaryskeleton-3bjf7r", {
  minHeight: "2.25rem",
  width: "100%"
});
const _staticStyles5 = _cssRef("header-dropdown__locationprimaryreserve-0h2jry", {
  opacity: 0
});
const _staticStyles6 = _cssRef("header-dropdown__phoneskeleton-17l25m", {
  width: "256px",
  height: "48px"
});
const _staticStyles7 = _cssRef("header-dropdown__actionbuttonsrowset-00qoxr", {
  textAlign: "center",
  width: "unset"
});
import React from 'react';
import { useCtaProvider } from '../../../contexts/franchise/cta-provider';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import RatingSummary from '../../franchise/nearest/rating-summary';
import Color from '../../primitives/colors';
import Skeleton from '../../primitives/skeleton';
import RowSet from '../../primitives/grid/row-set';
import Typography from '../../primitives/typography';
import StyledPillButton, { StyledPillButtonAsLink } from '../../primitives/styled-pill-button';
import { StyledButtonAsLink } from '../../primitives/styled-button';
import triggerInvoca from '../../../invoca/trigger-invoca';
import ChangeLocationDrawer from '../../franchise/nearest/change-location-drawer';
import PhoneNumber from '../../primitives/phone-number';
import { useLocator } from '../../../contexts/franchise/locator-provider';
import { CHANGE_LOCATION, LOCAL_CITY_LOCATION, LOCATION_PRIMARY_SKELETON_PLACEHOLDER, NATIONAL_CALL_CENTER_LOCATION, PHONE_NUMBER, PHONE_NUMBER_DISPLAY, YOUR_DETECTED_LOCATION, YOUR_SELECTED_LOCATION, NATIONAL_CALL_CENTER_DISPLAY } from '../../../constants';
import formatPhoneLink, { toTelHref } from '../../utils/format-phone-link';
import type { FranchiseReviewSummary } from '../../../sourcing/testimonials/franchise-review';
const styles = {
  headerDropdownContainer: _staticStyles,
  headerDropdownInnerContainer: _staticStyles2,
  locationTextRowSet: _staticStyles3,
  locationPrimarySkeleton: _staticStyles4,
  locationPrimaryReserve: _staticStyles5,
  phoneSkeleton: _staticStyles6,
  actionButtonsRowSet: _staticStyles7
};
const HeaderDropdown = (): JSX.Element => {
  const {
    loading: geoIsLoading,
    geo: locatorGeo,
    franchise: locatorFranchise,
    locationChangedByUser,
    isNationalCallCenter
  } = useLocator();
  React.useEffect(() => {
    triggerInvoca();
  }, []);
  const [locationChangeVisible, setLocationChangeVisible] = React.useState<boolean>(false);
  const onChangeLocation = (): void => {
    setLocationChangeVisible(true);
  };
  const {
    hideFranchiseLink
  } = useCtaProvider();
  const {
    isLocalCityPage,
    franchise: micrositeFranchise
  } = useMicrosite();
  const geo = locatorGeo;
  const franchise = micrositeFranchise || locatorFranchise?.data;
  const disableChangeLocation = !!micrositeFranchise;
  const frId = franchise?.franchiseNumber;
  const frLink = franchise?.permalink;
  const reviewSummary = (franchise as {
    reviewSummary?: FranchiseReviewSummary;
  } | undefined)?.reviewSummary;
  const frName = franchise?.name;
  const frPhone = franchise?.mainPhone;
  const locationPrimaryPending = geoIsLoading || !geo?.city || !frName;
  return <div {..._mergeProps({
    css: styles.headerDropdownContainer,
    role: "region",
    "aria-label": "Location information"
  })}>
            <ChangeLocationDrawer visible={locationChangeVisible} onClose={() => setLocationChangeVisible(false)} />
            <div>
                <div {..._mergeProps({
        css: styles.headerDropdownInnerContainer
      })}>
                    <RowSet breakpoints={{
          dt: {
            between: 20
          }
        }}>
                        <RowSet {..._mergeComponentProps({
            breakpoints: {
              dt: {
                between: 8
              }
            },
            css: styles.locationTextRowSet
          })}>
                            <Color color="primaryOrange">
                                <span id="location-type-label">
                                    {isLocalCityPage && !hideFranchiseLink && LOCAL_CITY_LOCATION}
                                    {locationChangedByUser && !isLocalCityPage && !hideFranchiseLink && !isNationalCallCenter && YOUR_SELECTED_LOCATION}
                                    {!locationChangedByUser && !isLocalCityPage && !hideFranchiseLink && !isNationalCallCenter && YOUR_DETECTED_LOCATION}
                                    {(hideFranchiseLink || isNationalCallCenter) && !isLocalCityPage && NATIONAL_CALL_CENTER_LOCATION}
                                </span>
                            </Color>
                            {!isNationalCallCenter && !isLocalCityPage && !locationChangedByUser && <Skeleton {..._mergeComponentProps({
              css: styles.locationPrimarySkeleton,
              "aria-busy": geoIsLoading
            })}>
                                    {locationPrimaryPending ? <Typography {..._mergeComponentProps({
                fontSize: "3xl",
                fontWeight: "medium",
                css: styles.locationPrimaryReserve,
                "aria-hidden": true
              })}>
                                            {LOCATION_PRIMARY_SKELETON_PLACEHOLDER}
                                        </Typography> : <Typography id="location-city-name" fontSize="3xl" fontWeight="medium">
                                            {geo.city}
                                            {geo?.stateShort ? ', ' : ' '}
                                            {geo?.stateShort || ''}
                                        </Typography>}
                                </Skeleton>}
                            {!isNationalCallCenter && !isLocalCityPage && locationChangedByUser && <Skeleton {..._mergeComponentProps({
              css: styles.locationPrimarySkeleton,
              "aria-busy": geoIsLoading
            })}>
                                    {locationPrimaryPending ? <Typography {..._mergeComponentProps({
                fontSize: "3xl",
                fontWeight: "medium",
                css: styles.locationPrimaryReserve,
                "aria-hidden": true
              })}>
                                            {LOCATION_PRIMARY_SKELETON_PLACEHOLDER}
                                        </Typography> : <Typography id="location-city-name" fontSize="3xl" fontWeight="medium">
                                            {frName}
                                        </Typography>}
                                </Skeleton>}
                            {isLocalCityPage && <Skeleton {..._mergeComponentProps({
              css: styles.locationPrimarySkeleton,
              "aria-busy": !franchise
            })}>
                                    <Typography id="location-city-name" fontSize="3xl" fontWeight="medium">
                                        {franchise?.address?.city}
                                        {franchise?.address?.state ? ', ' : ' '}
                                        {franchise?.address?.state || ''}
                                    </Typography>
                                </Skeleton>}
                            {(hideFranchiseLink || isNationalCallCenter) && !isLocalCityPage && <Typography id="location-city-name" fontSize="3xl" fontWeight="medium">
                                    {NATIONAL_CALL_CENTER_DISPLAY}
                                </Typography>}
                            {(!isNationalCallCenter && !hideFranchiseLink && !locationChangedByUser || isLocalCityPage) && <Skeleton aria-busy={!frName}>
                                    {frName && <Typography fontSize="sm">{frName}</Typography>}
                                </Skeleton>}
                            {reviewSummary?.shouldDisplay && !hideFranchiseLink && !isNationalCallCenter && typeof reviewSummary.rating === 'number' && typeof reviewSummary.count === 'number' && <RatingSummary count={reviewSummary.count} rating={reviewSummary.rating} />}
                        </RowSet>
                        <Skeleton {..._mergeComponentProps({
            css: styles.phoneSkeleton,
            isButton: true,
            backgroundColor: "primaryOrange",
            "aria-busy": !frPhone && !hideFranchiseLink
          })}>
                            {frPhone && !hideFranchiseLink && <PhoneNumber as={StyledButtonAsLink} dialNumber={frPhone} to={toTelHref(frPhone)} aria-label={`Call ${formatPhoneLink(frPhone)}`} aria-describedby="location-type-label location-city-name">
                                    {formatPhoneLink(frPhone)}
                                </PhoneNumber>}
                            {hideFranchiseLink && <PhoneNumber as={StyledButtonAsLink} dialNumber={PHONE_NUMBER} to={toTelHref(PHONE_NUMBER)} aria-label={`Call ${PHONE_NUMBER_DISPLAY}`} aria-describedby="location-type-label location-city-name">
                                    {PHONE_NUMBER_DISPLAY}
                                </PhoneNumber>}
                        </Skeleton>
                    </RowSet>
                    <RowSet {..._mergeComponentProps({
          breakpoints: {
            dt: {
              between: 18
            }
          },
          css: styles.actionButtonsRowSet
        })}>
                        {!disableChangeLocation && !hideFranchiseLink && !isLocalCityPage && <div>
                                Need help elsewhere?
                                {' '}
                                <StyledPillButton className="change-location-open-cta" onClick={onChangeLocation} aria-haspopup="dialog" aria-label="Change your location">
                                    {CHANGE_LOCATION}
                                    {' '}
                                    ›
                                </StyledPillButton>
                            </div>}
                        {isLocalCityPage && <div>
                                Need help elsewhere?
                                {' '}
                                <StyledPillButtonAsLink to="/locations" aria-label="Change your location">
                                    {CHANGE_LOCATION}
                                    {' '}
                                    ›
                                </StyledPillButtonAsLink>
                            </div>}
                        <Typography fontSize="xl" fontWeight="medium" color="primaryOrange">
                            24/7 Emergency Service
                        </Typography>
                        {!!frId && !hideFranchiseLink && frLink && <StyledPillButtonAsLink to={frLink}>
                                Find Out More ›
                            </StyledPillButtonAsLink>}
                    </RowSet>
                </div>
            </div>
        </div>;
};
export default HeaderDropdown;